module.exports = __webpack_public_path__ + "img/landscape_icon.2a83e406.png";